import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=53e5c5e8&"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js&"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports